import React from 'react';

type ChartLegendProps = {
  color: string;
  children: React.ReactNode;
};

type AreaChartLegendProps = ChartLegendProps & { lightOpacity: number };

export const AreaChartLegend = ({
  color,
  children,
  lightOpacity,
}: AreaChartLegendProps) => {
  return (
    <>
      <div className="highcharts-legend-symbol-area">
        <div
          style={{ backgroundColor: color }}
          className="highcharts-legend-symbol-area-dark"></div>
        <div
          style={{ backgroundColor: color, opacity: lightOpacity }}
          className="highcharts-legend-symbol-area-light"></div>
      </div>
      {children}
    </>
  );
};

export const LineChartLegend = ({ color, children }: ChartLegendProps) => {
  return (
    <>
      <div
        className="highcharts-legend-symbol-line"
        style={{ backgroundColor: color }}></div>
      {children}
    </>
  );
};

export const LineCircleChartLegend = ({
  color,
  children,
}: ChartLegendProps) => {
  return (
    <>
      <div
        className="highcharts-legend-symbol-line-circle"
        style={{ backgroundColor: color }}>
        <div className="circle-large" style={{ backgroundColor: color }}>
          <div className="circle-small"></div>
        </div>
      </div>
      {children}
    </>
  );
};

export const CircleChartLegend = ({ color, children }: ChartLegendProps) => {
  return (
    <>
      <div className="circle-large" style={{ backgroundColor: color }}></div>
      {children}
    </>
  );
};

export const highchartsStockHandlesOptions: Highcharts.NavigatorOptions = {
  handles: {
    width: 17,
    height: 28,
  },
};

export const highchartsNavigatorMaskOptions: Highcharts.NavigatorOptions = {
  maskInside: false,
};

export const marker: Highcharts.PlotSeriesOptions = {
  marker: {
    radius: 2,
    lineColor: 'white',
  },
};
